import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
//import Layout from "../components/layout/Layout";
// import Analysis from "../pages/dashboard/Analysis";
import MyWallet from "../pages/dashboard/MyWallet";
import SmartIot from "../pages/dashboard/SmartIot";
import AuthLayout from "../components/layout/AuthLayout";
// import Signin from "../pages/auth/Signin";
// import Signup from "../pages/auth/Signup";
import ForgotPassword from "../pages/auth/ForgotPassword";
import TwoStep from "../pages/auth/TwoStep";
import Lockscreen from "../pages/auth/Lockscreen";
import Maintenance from "../pages/auth/Maintenance";
import PageNotFound from "../pages/auth/PageNotFound";
import Calendar from "../pages/app/Calendar";
import TuiCalendar from "../pages/app/TuiCalendar";
import Email from "../pages/app/email/Email";
import EmailDetail from "../pages/app/email/EmailDetail";
import EmailCompose from "../pages/app/email/EmailCompose";
import Chat from "../pages/app/Chat";
import Campaign from "../pages/app/campaign/Campaign";
import Social from "../pages/app/social/Social";
import FileManager from "../pages/app/fileManager/FileManager";
import Todo from "../pages/app/Todo";
import Contact from "../pages/app/contact/Contact";
import Task from "../pages/app/task/Task";
import ProjectList from "../pages/app/project/projectList/ProjectList";
import ProjectDetail from "../pages/app/project/projectDetail/ProjectDetail";
import MyProfile from "../pages/page/myProfile/MyProfile";
import Bookmark from "../pages/page/Bookmark";
import Timeline from "../pages/page/Timeline";
import ImageGallery from "../pages/page/ImageGallery";
import Pricing from "../pages/page/Pricing";
import TeamBorad from "../pages/page/TeamBorad";
import SupportTicket from "../pages/page/SupportTicket";
import Faq from "../pages/page/Faq";
import SearchPage from "../pages/page/SearchPage";
import Footers from "../pages/page/Footers";
import Setting from "../pages/account/Setting";
import Invoice from "../pages/account/Invoice";
import Billing from "../pages/account/Billing";
import CreateInvoice from "../pages/account/CreateInvoice";
import Modals from "../pages/Modals";
import Overview from "../pages/documentation/Overview";
import DevSetup from "../pages/documentation/DevSetup";
import FileStructure from "../pages/documentation/FileStructure";
import References from "../pages/documentation/References";
import HelperClass from "../pages/documentation/HelperClass";
import ChangeLog from "../pages/documentation/ChangeLog";
import Widget from "../pages/Widget";
import LogIn from "../pages/page/LogIn";
import Register from "../pages/page/Register";
import PageUserConfirmation from "../pages/auth/PageUserConfirmation";
import ParentLayout from "../components/layout/ParentLayout";
import UserMasterLayout from "../components/layout/UserMasterLayout";
import ForgotPasswordStep2 from "../pages/auth/ForgorPasswordStep2";
import Addresses from "../pages/Addresses";
import Packages from "../pages/Packages";
import AddressContact from "../pages/AddressContact";
import TrackingLayout from "../components/layout/TrackingLayout";
import Tracking from "../pages/Tracking";
import Notifications from "../pages/Notifications";
import DeliveryLayout from "../components/layout/DeliveryLayout";
import DeliveryRequest from "../pages/DeliveryRequest";
import AskContractLayout from "../components/layout/AskContractLayout";
import AskContract from "../pages/AskContract";
import Landing from "../pages/Landing/index";
import LandingLayout from "../components/layout/LandingLayout";
import DrUserWrapperLayout from "../components/layout/DrUserWrapperLayout";


import Service from "../pages/Landing/pages/Service";
import ServicesPage from "../pages/Landing/pages/ServicesPage";
import FAQPage from "../pages/Landing/pages/FAQPage";
import TermsPage from "../pages/Landing/pages/TermsPage";
import ContactUsPage from "../pages/Landing/pages/ContactUsPage";
import NewsPage from "../pages/Landing/pages/NewsPage";
import NewsInner from "../pages/Landing/pages/NewsInner";
import CustomableShipmentPage from "../pages/Landing/pages/CustomableShipmentPage";
import SubUsers from "../pages/SubUsers";
import NewAddresses from "../pages/NewAddresses";
import NewAddressContacts from "../pages/NewAddressContacts";
import Invoices from "../pages/Invoices";
import PaymentSuccess from "../pages/Landing/pages/PaymentSuccess";
import PaymentFail from "../pages/Landing/pages/PaymentFail";

export default function Routers() {
  const RouterContent = () => {
    const pageUrl = useLocation().pathname;

    useEffect(() => {
      const pageClass = pageUrl.substring(1).replace(/\//g, "-");
      document.body.classList.add(pageClass ? pageClass : "dashboard");
      return () => {
        document.body.classList.remove(pageClass ? pageClass : "dashboard");
      };
    }, [pageUrl]);
    //console.log(pageUrl);

    return (
      <Routes>
        <Route element={<LandingLayout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:id" element={<Service />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:id" element={<NewsInner />} />
          <Route path="/shipment" element={<CustomableShipmentPage />} />
          <Route path="/shipment/:id" element={<CustomableShipmentPage />} />
          <Route path="/paymentsuccess" element={<PaymentSuccess />} />
          <Route path="/paymentfailed" element={<PaymentFail />} />
        </Route>
        <Route element={<UserMasterLayout />}>
          <Route path="/u-delivery-request" element={<DrUserWrapperLayout />} />
        </Route>
        <Route element={<ParentLayout />}>
          <Route path="/auth" element={<LogIn />} />
          <Route path="/index-wallet" element={<MyWallet />} />
          <Route path="/index-iot" element={<SmartIot />} />
          <Route path="/app-calendar" element={<Calendar />} />
          <Route path="/app-calendar-tui" element={<TuiCalendar />} />
          <Route path="/app-email" element={<Email />} />
          <Route path="/app-email-detail" element={<EmailDetail />} />
          <Route path="/app-email-compose" element={<EmailCompose />} />
          <Route path="/app-chat" element={<Chat />} />
          <Route path="/app-campaign" element={<Campaign />} />
          <Route path="/app-social" element={<Social />} />
          <Route path="/app-file-manager" element={<FileManager />} />
          <Route path="/app-todo" element={<Todo />} />
          <Route path="/app-contact" element={<Contact />} />
          <Route path="/app-task" element={<Task />} />
          <Route path="/app-project" element={<ProjectList />} />
          <Route path="/app-project-detail" element={<ProjectDetail />} />
          <Route path="/page-my-profile" element={<MyProfile />} />
          <Route path="/page-bookmark" element={<Bookmark />} />
          <Route path="/page-timeline" element={<Timeline />} />
          <Route path="/page-image-gallery" element={<ImageGallery />} />
          <Route path="/page-pricing" element={<Pricing />} />
          <Route path="/page-team-board" element={<TeamBorad />} />
          <Route path="/page-support-ticket" element={<SupportTicket />} />
          <Route path="/page-faq" element={<Faq />} />
          <Route path="/page-search" element={<SearchPage />} />
          <Route path="/page-footer" element={<Footers />} />
          <Route path="/account-setting" element={<Setting />} />
          {/* <Route path="/account-addresses" element={<Addresses />} /> */}
          <Route path="/account-addresses" element={<NewAddresses />} />
          <Route
            path="/account-addresses/:id"
            element={<NewAddressContacts />}
          />
          {/* <Route path="/account-addresses/:id" element={<NewAddressContacts />} /> */}
          <Route path="/account-invoices" element={<Invoices />} />
          <Route path="/account-invoice" element={<Invoice />} />
          <Route path="/account-billing" element={<Billing />} />
          <Route path="/account-create-invoice" element={<CreateInvoice />} />
          <Route path="/modals" element={<Modals />} />
          <Route path="/doc-overview" element={<Overview />} />
          <Route path="/doc-setup" element={<DevSetup />} />
          <Route path="/doc-structure" element={<FileStructure />} />
          <Route path="/doc-references" element={<References />} />
          <Route path="/doc-helperclass" element={<HelperClass />} />
          <Route path="/doc-changelog" element={<ChangeLog />} />
          <Route path="/widget" element={<Widget />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/notifications" element={<Notifications />} />

          <Route path="/sub-users" element={<SubUsers />} />
        </Route>
        <Route element={<TrackingLayout />}>
          <Route path="/tracking" element={<Tracking />} />
          <Route path="/tracking/:id" element={<Tracking />} />
        </Route>
        <Route element={<AskContractLayout />}>
          <Route path="/ask-contract" element={<AskContract />} />
        </Route>
        <Route element={<DeliveryLayout />}>
          <Route path="/delivery-request" element={<DeliveryRequest />} />
        </Route>
        <Route element={<AuthLayout />}>
          {/* <Route path="/auth-signin" element={<Signin />} /> */}
          <Route path="/auth-signin" element={<LogIn />} />
          {/* <Route path="/auth-signup" element={<Signup />} /> */}
          <Route path="/auth-signup" element={<Register />} />
          <Route
            path="/auth-forgot-password-step-2"
            element={<ForgotPasswordStep2 />}
          />
          <Route path="/auth-forgot-password" element={<ForgotPassword />} />
          <Route path="/auth-two-step" element={<TwoStep />} />
          <Route path="/auth-lockscreen" element={<Lockscreen />} />
          <Route path="/auth-maintenance" element={<Maintenance />} />
          <Route path="/auth-confirmation" element={<PageUserConfirmation />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    );
  };

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <RouterContent />
    </BrowserRouter>
  );
}
